import { useMountEffect } from "client/hooks/utils/useMountEffect";
import { gtag } from "client/utils/adsense/gtag";
import { getTaskIdsFromUrlParams } from "client/utils/getTaskIdsFromUrlParams";
import { useRouter } from "next/router";
import { useAppSelector } from "store/store";
import translatedRoutedSlugs, { type TranslatedRouteSlugs } from "translatedRouteSlugs";
import { useUrlTaskIds } from "./useUrlTaskIds";

export const useBulkResize = () => {
    const { locale } = useRouter();
    const fromDownloadPage = useAppSelector((store) => store.bulkResize.fromDownloadPage);

    const handleEditorPageLoadedAnalytics = () => {
        ///event
        gtag("event", "Editor Loaded", {
            event_category: "Bulk Resizer",
            event_label: "Editor Page",
        });
    };
    const { handleUrlTaskIds } = useUrlTaskIds();
    useMountEffect(() => {
        const urlTaskIds = getTaskIdsFromUrlParams();
        urlTaskIds.length > 0 && handleUrlTaskIds(urlTaskIds);
        if (!fromDownloadPage && urlTaskIds.length === 0) {
            window.location.href =
                locale === "en"
                    ? "/bulk-resize"
                    : `/${locale}/${
                          translatedRoutedSlugs["/bulk-resize"]?.[
                              (locale as keyof TranslatedRouteSlugs["/bulk-resize/editor"]) ?? "en"
                          ] ?? "bulk-resize"
                      }`;
        }
        handleEditorPageLoadedAnalytics();
    }, useBulkResize.name);
};
